"use strict"

import {query, mutation, subscription} from "./graphql"
import { recorderClient } from "@/plugins/hylable-sdk"

const gql = recorderClient.gql

export default {
  async list(params){
    let items = []
    let nextToken = null
    for(;;) {
      const res = await gql.run(query.listRecorders, {filter: {organizationId: {eq: params.oid}}, nextToken})
      items = items.concat(res.items)
      nextToken = res.nextToken
      if(!nextToken) break
    }
    return items.map(createRecorderInstance)
  },
  Subscribe(params, callback, id){
    const cb = (r) => callback(r)
    return gql.subscribe(subscription.onUpdateRecorder, {organizationId: params.oid}, cb, id)
  },
  Unsubscribe(id){
    gql.unsubscribe(id)
  },
  async rec(params){
    const res = await gql.run(mutation.recStart, {
      organizationId: params.oid,
      input: params.input,
    })
    console.log("REC: start", params.input.map(r => r.recorderId))
    return res
  },
  async stop(params){
    const res = await gql.run(mutation.recStop, {
      organizationId: params.oid,
      input: params.input,
    })
    console.log("REC : stop", params.input)
    return res
  },
  async reboot(params){
    const res = await gql.run(mutation.reboot, {
      organizationId: params.oid,
      input: params.input,
    })
    console.log("REBOOT : start", params.input.map(r => r.recorderId))
    return res
  },
  async shutdown(params){
    const res = await gql.run(mutation.shutdown, {
      organizationId: params.oid,
      input: params.input,
    })
    console.log("SHUTDOWN : start", params.input)
    return res
  },
  async assign(params){
    const res = await gql.run(mutation.setAssign, {
      organizationId: params.oid,
      input: params.input,
    })
    console.log("ASSIGN : start", params.input)
    return res
  },
}

function createRecorderInstance(recorder) {
  if (!recorder) return null

  let network = {}
  if (recorder.network) {
    try {
      network = JSON.parse(recorder.network)
    } catch (e) {
      console.error(`Failed to parse network for ID: ${recorder.id}`, e)
    }
  }

  return {
    ...recorder,
    network
  }
}